import { render, staticRenderFns } from "./KeywordFinder.vue?vue&type=template&id=0ccdba71&scoped=true&"
import script from "./KeywordFinder.vue?vue&type=script&lang=ts&"
export * from "./KeywordFinder.vue?vue&type=script&lang=ts&"
import style0 from "./KeywordFinder.vue?vue&type=style&index=0&id=0ccdba71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccdba71",
  null
  
)

export default component.exports